import React from 'react';
import { useNavigate } from 'react-router-dom';

const ResourcesPage = () => {
  const navigate = useNavigate();

  const resources = [
    {
      title: 'Downloadable Worksheets',
      description: 'Fun activities you can print and do offline',
      icon: '📄',
      category: 'Worksheets'
    },
    {
      title: 'Educational Tips',
      description: 'Tips for parents and teachers to support learning',
      icon: '💡',
      category: 'Tips'
    },
    {
      title: 'Fun Experiments',
      description: 'Interactive experiments to learn English concepts',
      icon: '🔬',
      category: 'Experiments'
    },
    {
      title: 'Reading Materials',
      description: 'Additional stories and reading resources',
      icon: '📖',
      category: 'Reading'
    }
  ];

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      fontFamily: "'Nunito', sans-serif",
      backgroundColor: '#F4ABBA',
      color: '#333',
      padding: '40px 20px',
      paddingTop: '100px'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <button
          onClick={() => navigate('/')}
          style={{
            backgroundColor: 'white',
            color: '#DD2E44',
            padding: '10px 25px',
            borderRadius: '20px',
            border: '2px solid #DD2E44',
            fontSize: '16px',
            fontWeight: '700',
            cursor: 'pointer',
            marginBottom: '40px'
          }}
        >
          ← Back to Home
        </button>

        <h1 style={{
          fontSize: '48px',
          fontWeight: '800',
          color: '#DD2E44',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          Resources
        </h1>
        <p style={{
          fontSize: '24px',
          color: '#666',
          textAlign: 'center',
          marginBottom: '50px'
        }}>
          Downloadable materials, tips, and fun activities
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '30px',
          marginBottom: '50px'
        }}>
          {resources.map((resource, index) => (
            <div
              key={index}
              style={{
                backgroundColor: 'white',
                padding: '40px',
                borderRadius: '25px',
                boxShadow: '0 4px 15px rgba(221, 46, 68, 0.15)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                border: '2px solid transparent'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(221, 46, 68, 0.25)';
                e.currentTarget.style.borderColor = '#DD2E44';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(221, 46, 68, 0.15)';
                e.currentTarget.style.borderColor = 'transparent';
              }}
            >
              <div style={{ fontSize: '64px', marginBottom: '20px', textAlign: 'center' }}>
                {resource.icon}
              </div>
              <div style={{
                backgroundColor: '#FFF5F7',
                padding: '8px 16px',
                borderRadius: '15px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#DD2E44',
                display: 'inline-block',
                marginBottom: '15px'
              }}>
                {resource.category}
              </div>
              <h3 style={{
                fontSize: '24px',
                fontWeight: '700',
                color: '#DD2E44',
                marginBottom: '15px'
              }}>
                {resource.title}
              </h3>
              <p style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.6'
              }}>
                {resource.description}
              </p>
              <button
                style={{
                  marginTop: '20px',
                  backgroundColor: '#DD2E44',
                  color: 'white',
                  padding: '12px 24px',
                  borderRadius: '20px',
                  border: 'none',
                  fontSize: '16px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  width: '100%'
                }}
              >
                View Resources →
              </button>
            </div>
          ))}
        </div>

        {/* Educational Tips Section */}
        <div style={{
          backgroundColor: 'white',
          padding: '50px',
          borderRadius: '25px',
          boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
          marginTop: '40px'
        }}>
          <h2 style={{
            fontSize: '36px',
            fontWeight: '800',
            color: '#DD2E44',
            marginBottom: '30px',
            textAlign: 'center'
          }}>
            Educational Tips for Parents & Teachers
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '30px'
          }}>
            <div>
              <h3 style={{ fontSize: '22px', fontWeight: '700', color: '#DD2E44', marginBottom: '15px' }}>
                ⏰ Short Sessions
              </h3>
              <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6' }}>
                Younger children (6-7) have short attention spans. Keep sessions to 5-10 minutes with breaks.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '22px', fontWeight: '700', color: '#DD2E44', marginBottom: '15px' }}>
                🎯 Age-Appropriate Activities
              </h3>
              <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6' }}>
                Choose activities that match your child's cognitive stage for optimal learning.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '22px', fontWeight: '700', color: '#DD2E44', marginBottom: '15px' }}>
                🏆 Celebrate Progress
              </h3>
              <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6' }}>
                Praise effort and celebrate achievements to keep children motivated.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourcesPage;